import React from 'react'
import { Link } from "react-router-dom"
import Blog_1 from '../../../assets/images/blog/blog-single-1.jpg'
import Blog_2 from '../../../assets/images/blog/blog-single-2.jpg'
import Blog_3 from '../../../assets/images/blog/blog-single-3.jpg'
import Blog_4 from '../../../assets/images/blog/blog-single-4.jpg'
import Blog_5 from '../../../assets/images/svg/header/Search.svg'
import Blog_6 from '../../../assets/images/blog/blog-single-5.jpg'
import Blog_7 from '../../../assets/images/blog/blog-single-6.jpg'
import Blog_8 from '../../../assets/images/blog/blog-single-7.jpg'
import Blog_9 from '../../../assets/images/blog/blog-single-8.jpg'
import Blog_10 from '../../../assets/images/blog/blog-single-9.jpg'
import Blog_11 from '../../../assets/images/blog/blog-single-10.jpg'
import Blog_12 from '../../../assets/images/blog/blog-single-11.jpg'


const Blog = () => {
  return (
    <>
      <div className="blog-single-section">
        <div className="container">
          <div className="row gutter-y-40">
            <div className="col-lg-8">
              <div
                className="blog-list-box animate fadeInLeft wow"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="blog-single-image">
                  <Link to="/BlogDetails">
                    <img
                      src={Blog_1}
                      alt="blog-image"
                    />
                  </Link>
                  <Link to="/BlogDetails">
                    <p>18</p>
                    <span>November</span>
                  </Link>
                </div>
                <div className="blog-single-meta">
                  <ul>
                    <li>
                      <span>by </span>
                      <Link to="/BlogDetails"> Johm Mathew</Link>
                    </li>
                    |
                    <li>
                      <Link to="/BlogDetails">Business</Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-single-details">
                  <h4>
                    <Link to="/BlogDetails">
                      New Consulting For Business Finance
                    </Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                    enim ad minim veniam, quis nostrud exercitation ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <Link
                    to="/BlogDetails"
                    className="btn btn-theme btn-outline-dark"
                  >
                    Read More +
                  </Link>
                </div>
              </div>
              <div
                className="blog-list-box animate fadeInLeft wow"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="blog-single-image">
                  <Link to="/BlogDetails">
                    <img
                      src={Blog_2}
                      alt="blog-image"
                    />
                  </Link>
                  <Link to="/BlogDetails">
                    <p>18</p>
                    <span>November</span>
                  </Link>
                </div>
                <div className="blog-single-meta">
                  <ul>
                    <li>
                      <span>by </span>
                      <Link to="/BlogDetails"> Johm Mathew</Link>
                    </li>
                    |
                    <li>
                      <Link to="/BlogDetails">Business</Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-single-details">
                  <h4>
                    <Link to="/BlogDetails">
                      Your brand is promise to your customer
                    </Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                    enim ad minim veniam, quis nostrud exercitation ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <Link
                    to="/BlogDetails"
                    className="btn btn-theme btn-outline-dark"
                  >
                    Read More +
                  </Link>
                </div>
              </div>
              <div
                className="blog-list-box animate fadeInLeft wow"
                data-wow-duration="1500ms"
                data-wow-delay="600ms"
              >
                <div className="blog-single-image">
                  <Link to="/BlogDetails">
                    <img
                      src={Blog_3}
                      alt="blog-image"
                    />
                  </Link>
                  <Link to="/BlogDetails">
                    <p>18</p>
                    <span>November</span>
                  </Link>
                </div>
                <div className="blog-single-meta">
                  <ul>
                    <li>
                      <span>by </span>
                      <Link to="/BlogDetails"> Johm Mathew</Link>
                    </li>
                    |
                    <li>
                      <Link to="/BlogDetails">Business</Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-single-details">
                  <h4>
                    <Link to="/BlogDetails">
                      Tracking Global News and Globalization
                    </Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                    enim ad minim veniam, quis nostrud exercitation ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <Link
                    to="/BlogDetails"
                    className="btn btn-theme btn-outline-dark"
                  >
                    Read More +
                  </Link>
                </div>
              </div>
              <div
                className="blog-list-box animate fadeInLeft wow"
                data-wow-duration="1500ms"
                data-wow-delay="800ms"
              >
                <div className="blog-single-image">
                  <Link to="/BlogDetails">
                    <img
                      src={Blog_4}
                      alt="blog-image"
                    />
                  </Link>
                  <Link to="/BlogDetails">
                    <p>18</p>
                    <span>November</span>
                  </Link>
                </div>
                <div className="blog-single-meta">
                  <ul>
                    <li>
                      <span>by </span>
                      <Link to="/BlogDetails"> Johm Mathew</Link>
                    </li>
                    |
                    <li>
                      <Link to="/BlogDetails">Business</Link>
                    </li>
                  </ul>
                </div>
                <div className="blog-single-details">
                  <h4>
                    <Link to="/BlogDetails">New Horizons and Emerging Markets</Link>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                    enim ad minim veniam, quis nostrud exercitation ullamco laboris
                    nisi ut aliquip ex ea commodo consequat.
                  </p>
                  <Link
                    to="/BlogDetails"
                    className="btn btn-theme btn-outline-dark"
                  >
                    Read More +
                  </Link>
                </div>
              </div>
              <div
                className="pagination animate fadeInLeft wow"
                data-wow-duration="1500ms"
                data-wow-delay="1000ms"
              >
                <div className="blog-pagination-btn active">
                  <Link to="#">1</Link>
                </div>
                <div className="blog-pagination-btn">
                  <Link to="#">2</Link>
                </div>
                <div className="blog-pagination-btn">
                  <Link to="#">
                    <i className="fa-solid fa-chevron-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="blog-sidebar">
                <div
                  className="blog-block animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  <div className="blog-serch-widget">
                    <form action="#">
                      <input type="search" placeholder="Search Here ... " />
                      <button type="submit">
                        <img src={Blog_5} alt="icon" />
                      </button>
                    </form>
                  </div>
                </div>
                <div
                  className="blog-block animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="400ms"
                >
                  <div className="category-widget">
                    <h4>Categories</h4>
                    <ul>
                      <li>
                        <Link to="#">Accounting</Link> <span>+</span>
                      </li>
                      <li>
                        <Link to="#">Business</Link> <span>+</span>
                      </li>
                      <li>
                        <Link to="#">Economics</Link> <span>+</span>
                      </li>
                      <li>
                        <Link to="#">Investment</Link> <span>+</span>
                      </li>
                      <li>
                        <Link to="#">Marketing</Link> <span>+</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="blog-block animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="600ms"
                >
                  <div className="recent-blog-widget">
                    <h4>Recent Post</h4>
                    <div className="recent-blog-widget-item">
                      <img
                        src={Blog_6}
                        alt="blog-image"
                      />
                      <div className="recent-blog-widget-item-title">
                        <span>18 November 2024 </span>
                        <Link to="/BlogDetails">
                          Your brand is your promise to your customer{" "}
                        </Link>
                      </div>
                    </div>
                    <div className="recent-blog-widget-item">
                      <img
                        src={Blog_7}
                        alt="blog-image"
                      />
                      <div className="recent-blog-widget-item-title">
                        <span>September 20, 2023</span>
                        <Link to="/BlogDetails">
                          Process of giving a meaning to specific organization
                        </Link>
                      </div>
                    </div>
                    <div className="recent-blog-widget-item">
                      <img
                        src={Blog_8}
                        alt="blog-image"
                      />
                      <div className="recent-blog-widget-item-title">
                        <span>September 20, 2023</span>
                        <Link to="/BlogDetails">
                          New Consulting For Business Finance
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="blog-block animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="800ms"
                >
                  <div className="tag-widget">
                    <h4>Our Tags</h4>
                    <ul>
                      <li>
                        <Link to="#">marketing</Link>
                      </li>
                      <li>
                        <Link to="#">Business</Link>
                      </li>
                      <li>
                        <Link to="#">Consulting</Link>
                      </li>
                      <li>
                        <Link to="#">Finance</Link>
                      </li>
                      <li>
                        <Link to="#">Bank</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="blog-block cta-widget animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="1000ms"
                >
                  <div className="bolg-cta-widget">
                    <h4>Request a Call Back</h4>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor incididunt.
                    </p>
                    <Link to="tel:(234) 109-6666" className="tel">
                      (234) 109-6666
                    </Link>
                    <Link to="/Contact" className="btn btn-secondary btn-theme">
                      Contact Us +
                    </Link>
                  </div>
                </div>
                <div
                  className="blog-block mb-0 animate fadeInRight wow"
                  data-wow-duration="1500ms"
                  data-wow-delay="1200ms"
                >
                  <div className="insta-post-widget">
                    <h4>Instagram Post</h4>
                    <div className="insta-post">
                      <Link to="#" className="insta-image">
                        <img
                          src={Blog_9}
                          alt="insta-image"
                        />
                      </Link>
                      <Link to="#" className="insta-image">
                        <img
                          src={Blog_10}
                          alt="insta-image"
                        />
                      </Link>
                      <Link to="#" className="insta-image">
                        <img
                          src={Blog_11}
                          alt="insta-image"
                        />
                      </Link>
                      <Link to="#" className="insta-image">
                        <img
                          src={Blog_12}
                          alt="insta-image"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
export default Blog
